import * as Yup from "yup";
import { baseUserFields } from "../shared/validation";

const FormEditUserValidationSchema = Yup.object().shape({
  ...baseUserFields,
});

export default FormEditUserValidationSchema;
